export const baseApiUrl = process.env.VUE_APP_BASE_API_URL
export const sandboxApi = process.env.VUE_APP_ACCESS_TOKEN
export const deployPath = process.env.VUE_APP_DEPLOY_PATH
// export const baseApiUrl = 'http://localhost:4010'
